import { IconBrandLine, IconLifebuoy, IconTicket } from '@tabler/icons-react';
import { Button, Icon } from '@hevoio/hevo-ui-toolkit';
import styles from './SupportOptionsContainer.module.scss';

export default function SupportOptionsContainer({
  onCreateConversation,
  onRaiseTicket
}: {
  onCreateConversation: () => void;
  onRaiseTicket: () => void;
}) {
  return (
    <div className='flex-col justify-center align-items-center h-100 p-6'>
      <div className={styles.iconBg}>
        <Icon SVGIcon={IconLifebuoy} size={5} className='text-primary' />
      </div>
      <div className='text-paragraph-small text-secondary text-center mt-5'>
        We apologize for not being able to resolve your issue. For further assistance, chat with one
        of our support engineers or create a support ticket.
      </div>

      <div className='mt-5'>
        <Button
          SVGIcon={IconBrandLine}
          iconClassName='mr-1'
          className='text-transform-none'
          onClick={onCreateConversation}
        >
          Chat with a support engineer
        </Button>
        <Button
          onClick={onRaiseTicket}
          iconClassName='mr-1'
          SVGIcon={IconTicket}
          className='ml-3 text-transform-none'
        >
          Raise a ticket
        </Button>
      </div>
    </div>
  );
}
